<template lang="pug">
table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
  thead.thead-light
    tr
      th.text-center(width="5%")
        span #
      th(width="20%")
        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
      th(v-if="!isOperator" width="25%")
        span(:title="$t('ui.parent_id')") {{ $t('ui.operator_id') }}
      th(width="25%")
        span(:title="$t('ui.contact_phone')") {{ $t('ui.contact_phone') }}
      th.text-right(width="25%")
        span(:title="$t('ui.signup_date')") {{ $t("ui.signup_date") }}
  tbody.clusterize-content
    tr(v-if="tbl.length == 0")
      td(:colspan="isOperator ? '4' : '5'").text-center
        span {{ $t('message.no_data_available') }}
    tr(v-for="(item, index) in tbl")
      td.text-center
        span(:title="index + 1") {{ index + 1 }}
      td
        span(:title="item.account_id") {{ item.account_id }}
      td(v-if="!isOperator")
        span(:title="item.parent_id") {{ item.parent_id }}
      td
        span(:title="item.contact_phone") {{ item.contact_phone }}
      td.text-right
        span(:title="$moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss') }}
</template>

<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  methods: { }
};
</script>